import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CheckDuplicateEmployeeCodeQuery,
  EmployeeApi,
  FindAccountToCreateEmployeeQuery,
  GenerateEmployeeCodeQuery,
} from 'api';

export const findEmployeeForTableList = createAsyncThunk(
  'employee/findEmployeeForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findAccountToCreateEmployee = createAsyncThunk(
  'employee/findAccountToCreateEmployee',
  async (option: FindAccountToCreateEmployeeQuery, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.findAccountToCreateEmployee(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEmployeeWithGroup = createAsyncThunk(
  'employee/findEmployeeWithGroup',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.findEmployeeWithGroup(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEntityAssignToUser = createAsyncThunk(
  'employee/findEntityAssignToUser',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.findEntityAssignToUser(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEmployee = createAsyncThunk(
  'employee/createEmployee',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityEmployee = createAsyncThunk(
  'employee/createEntityEmployee',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.createWithUser(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findEmployeeUser = createAsyncThunk(
  'employee/findEmployeeUser',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EmployeeApi.findOneEmployee(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEmployee = createAsyncThunk(
  'employee/updateEmployee',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EmployeeApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEmployeeUser = createAsyncThunk(
  'employee/updateEmployeeUser',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EmployeeApi.updateEmployeeUser(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEmployeeStatus = createAsyncThunk(
  'employee/updateEmployeeStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EmployeeApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEmployeeUserStatus = createAsyncThunk(
  'employee/updateEmployeeUserStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EmployeeApi.updateEmployeeUserStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEmployee = createAsyncThunk(
  'employee/deleteEmployee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEmployeeUser = createAsyncThunk(
  'employee/deleteEmployeeUser',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.deleteEmployeeUser(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkDuplicateEmployeeUserCode = createAsyncThunk(
  'employee/checkDuplicateEmployeeUserCode',
  async (query: CheckDuplicateEmployeeCodeQuery, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.checkDuplicateEmployeeCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const generateEmployeeUserCode = createAsyncThunk(
  'employee/generateEmployeeUserCode',
  async (query: GenerateEmployeeCodeQuery, { rejectWithValue }) => {
    try {
      const response = await EmployeeApi.generateEmployeeUserCode(query);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
  savedList: Array<any>;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
  savedList: [],
};

const employeeSlice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    reloadEmployee(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEmployee(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEmployee(state, action) {
      state.savedList = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(findEmployeeForTableList.fulfilled, (state, action) => {
        const { data } = action.payload;
        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
            phoneNumber: item.user.phoneNumber,
            type: item.type,
          };
        });

        state.tableList = newData;
      })
      .addCase(findAccountToCreateEmployee.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      });
  },
});

const { actions, reducer: employeeReducer } = employeeSlice;

export const {
  reloadEmployee,
  updateSavedPaginationEmployee,
  updateSavedListEmployee,
} = actions;

export default employeeReducer;
